import { DEFAULT_TERRITORY_CODE } from '~/app/components/ItemPage/ItemPageEdit/addons/ageGate';
import { ItemBlockedOverlay } from '~/app/components/ItemPage/ItemBlockedOverlay';
import { ItemBlockedText } from '~/app/components/ItemPage/ItemBlockedText';
import { selectUserCountry } from '~/app/lib/store/session/selectors';
import { AddonTypes } from '~/app/lib/songwhipApi/types';
import { useSelector } from '~/app/lib/store/redux';
import { useI18n } from '~/app/lib/i18n';

import { useItemContext } from '../ItemPageContext';

import { ExclusiveContentGate } from './ExclusiveContentGate';
import { PrivacyPolicyGate } from './PrivacyPolicyGate';
import { usePageGate } from './usePageGate';
import { AgeGate } from './AgeGate';
import { GateTypes } from './types';

type ItemPageGateProps = {
  children: React.ReactNode;
};

const ItemPageGate = ({ children }: ItemPageGateProps) => {
  const country = useSelector(selectUserCountry);
  const itemContext = useItemContext();
  const { t } = useI18n();

  const { type, unlock } = usePageGate(itemContext);

  switch (type) {
    case GateTypes.LOADING:
      return <ItemBlockedOverlay isLoading withLogo={false} />;

    case GateTypes.COUNTRY_BLOCKED:
      return (
        <ItemBlockedOverlay testId="countryBlocked">
          <ItemBlockedText text={t('item.countryBlocked')} />
        </ItemBlockedOverlay>
      );

    case GateTypes.PRIVACY_POLICY:
      return <PrivacyPolicyGate unlockPageGate={unlock} />;

    case GateTypes.AGE_BLOCKED: {
      const addon = itemContext.addons[AddonTypes.AGE_GATE] ?? {};
      const ageLimit = addon[country] ?? addon[DEFAULT_TERRITORY_CODE];

      return (
        <ItemBlockedOverlay testId="ageBlocked">
          <ItemBlockedText text={t('item.ageGate.error', { age: ageLimit })} />
        </ItemBlockedOverlay>
      );
    }

    case GateTypes.AGE_GATE:
      return <AgeGate itemContext={itemContext} unlockPageGate={unlock} />;

    case GateTypes.EXCLUSIVE_CONTENT:
      return (
        <ExclusiveContentGate
          itemContext={itemContext}
          unlockPageGate={unlock}
        />
      );

    default:
      return <>{children}</>;
  }
};

export default ItemPageGate;
